

import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import {UsersRolesManagementComponent} from './userRolesManagement-ang7'
import { DomainManagerModule } from './advancedManagement/domain-manager/domain-manager.module';
import { AdvancedManagementModule } from './advancedManagement/advancedManagement.module';
import { ProjectGroupsModule } from './advancedManagement/project-groups/project-groups.module';
import { ProjectManagementModule } from './project-management/project-management.module';
import { RolesManagementModule } from './roles-management/roles-management.module';
import { UserGroupsModule } from './usersManagement/users-groups/users-groups.module';
import { UsersModule } from './usersManagement/users/users.module';
import { OidcModule } from './advancedManagement/oidc-configuration/oidc.module';
import { UserManagementModule } from './usersManagement/usersManagement-module';

@NgModule({
    imports: [SharedModule,DomainManagerModule,OidcModule,ProjectGroupsModule,ProjectManagementModule,RolesManagementModule,UserGroupsModule,UsersModule,AdvancedManagementModule,UserManagementModule],
    declarations: [
        UsersRolesManagementComponent
    ],
    entryComponents: [UsersRolesManagementComponent],
    exports: [UsersRolesManagementComponent]
})
export class UsersRolesManagementModule {}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/userRolesManagement.module.ts